<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosya from "@/models/satdosya";
import AddEdit from "./addedit.vue";
import Drawer from "vue-simple-drawer";
import Swal from "sweetalert2";
import BirimSecimi from "../formcomponet/BirimSecimiAnaBirim.vue";
export default {
  mixins: [apibtoast, apigeneric, satdosya],
  page: {
    title: "Dosya İşlemleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
    Drawer,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("satdosya.Title"),
      items: [
        {
          text: this.$t("satdosya.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("satdosya.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("satdosya.Title"),
          active: true,
        },
      ],

      FilitrelemePenceresi: false,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      Filter: {
        dosyaadi: "",
        Dosyaacilistarih_ilk: "",
        Dosyaacilistarih_son: "",
        ihaleturu: "",
        alimturu: "",
        tamamlandi: "",
        ihaleyiyapanmakam: ""
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Alimturu: [],
      Ihaleturu: [],
      FilterBaslik: "",
    };
  },

  methods: {
    Get() {

      let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
this.ActionsFilterGet({Service: "ouygulama",  Page:Page,Filter:'&Kisaadi=SAT'}).then((ouygulama) => {
    if(ouygulama){
 
    this.ActionsFilterGet({Service: "ouserbirimyetki",  
    Page:Page,
    Filter:'&Uygulamaid='+ ouygulama.Data[0].Id + '&Userid='+this.UserUId}).then((ouserbirimyetki) => {
    if(ouserbirimyetki && ouserbirimyetki.Data.length > 0){
      
      var Filter = "";
     
     /* for(var i =0; i< ouserbirimyetki.Data.length; i++){
        Filter+="&Ihaleyiyapanmakamlar="+ouserbirimyetki.Data[i].Birimid
      }  */



      if (this.Filter.dosyaadi != "" && this.Filter.dosyaadi != null) {
        Filter = Filter + "&Dosyaadi=" + this.Filter.dosyaadi;
      }
      if (this.Filter.Dosyaacilistarih_ilk != "" && this.Filter.Dosyaacilistarih_ilk != null) {
        Filter = Filter + "&Dosyaacilistarih_ilk=" + this.Filter.Dosyaacilistarih_ilk;
      }
      if (this.Filter.Dosyaacilistarih_son != "" && this.Filter.Dosyaacilistarih_son != null) {
        Filter = Filter + "&Dosyaacilistarih_son=" + this.Filter.Dosyaacilistarih_son;
      }
      if (this.Filter.ihaleturu != "" && this.Filter.ihaleturu != null) {
        Filter = Filter + "&Ihaleturu=" + this.Filter.ihaleturu;
      }
      if (this.Filter.alimturu != "" && this.Filter.alimturu != null) {
        Filter = Filter + "&Alimturu=" + this.Filter.alimturu;
      }
      if (this.Filter.ihaleyiyapanmakam != "" && this.Filter.ihaleyiyapanmakam != null) {
        Filter = Filter + "&Ihaleyiyapanmakam=" + this.Filter.ihaleyiyapanmakam;
      }
      if (this.Filter.tamamlandi != "" && this.Filter.tamamlandi != null) {
        Filter = Filter + "&Tamamlandi=" + this.Filter.tamamlandi;
      }

      if (this.FilterBaslik.length > 2) {
        Filter = Filter + "&Dosyaadi=" + this.FilterBaslik;
      }

      Filter = Filter + "&Desc=dosyaacilistarih&Asc=tamamlandi"
      this.ActionsFilterGet({ Service: "SatDosya", Page: this.Page, Filter: Filter }).then((res) => {
        let degisecek = '"id"';
        let yenideger = '"Id"';

        let gelen_veri = res.Data.replaceAll(degisecek, yenideger);

        this.TableData = JSON.parse(gelen_veri);

        for (var i = 0; i < this.TableData.length; i++) {
          //this.$delete(this.TableData[i], "yaklasikmaliyetgorevliler");
          //this.$delete(this.TableData[i], "piyasaarastirmagorevliler");
          this.TableData[i].yaklasikmaliyetgorevliler = JSON.parse(this.TableData[i].yaklasikmaliyetgorevliler);
          this.TableData[i].piyasaarastirmagorevliler = JSON.parse(this.TableData[i].piyasaarastirmagorevliler);
          this.TableData[i].muayenekabulkomisyonu = JSON.parse(this.TableData[i].muayenekabulkomisyonu);
          this.TableData[i].tekniksartnamekomisyonu = JSON.parse(this.TableData[i].tekniksartnamekomisyonu);
        }

        this.Page.PageDataSize = this.TableData[0].totalcount;

        this.FilitrelemePenceresi = false;
      });

    }
});
    }
});
      this.Alimturu = [];
      this.ActionsSabitGet(1548).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          this.Alimturu.push({ Id: res.Data[i].Id, Value: res.Data[i].Value });
        }
      });

      this.Ihaleturu = [];
      this.ActionsSabitGet(1552).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          this.Ihaleturu.push({ Id: res.Data[i].Id, Value: res.Data[i].Value });
        }
      });
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    DeleteandDeleteStrHarcama(Id){
      let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
      this.ActionsFilterGet({
        Service: "StrBirimButceHarcamalari",
        Page: Page,
        Filter: "&Satdosyaid=" + Id
      }).then((resp) => {
        Swal.fire({
        title: this.$t("ToasMessage.DeletePopupBaslik"),
        text: this.$t("ToasMessage.DeletePopupContent"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
        cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
      }).then((result) => {
        if (result.value) {
          this.ActionsDelete({ Service: 'SatDosya', Id: Id }).then((res) => {
            if (res.Succeeded == true) {
              this.Get();
              this.$toast.success(this.$t("ToasMessage.DeletePozitif"));

              this.ActionsDelete({ Service: 'StrBirimButceHarcamalari', Id: resp.Data[0].Id }).then((res) => {
            if (res.Succeeded == true) {
              this.$toast.success('Başarılı, Harcama Kaydı Silindi');

            } else {
              this.$toast.error('Başarısız, Harcama Kaydı Silinemedi');
            }
          });
            } else {
              this.$toast.error(this.$t("ToasMessage.DeleteNegatif"));
            }
          });
        }
      });
          });
    }
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <input type="text" @input="FilterBaslik.length >= 3 || FilterBaslik.length == 0 ? Get() : ''"
                        v-model="FilterBaslik" class="form-control" placeholder="Arama..." />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer"><i
                        class="mdi mdi-card-search me-1"></i>{{ $t("satdosya.Page.Sorgula") }}</button>

                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.satdosya
                      @click="(DataUpdate = satdosyaData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i>{{
                        $t("satdosya.Page.YeniKayitEkle") }}</button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("satdosya.Table.dosyaadi") }}</th>
                      <th>{{ $t("satdosya.Table.birimadi") }}</th>
                      <th>{{ $t("satdosya.Table.ihaleturu") }}</th>
                      <th>{{ $t("satdosya.Table.alimturu") }}</th>
                      <th>{{ $t("satdosya.Table.dosyaacilistarih") }}</th>
                      <th style="width: 100px; text-align: center;">{{ $t("satdosya.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.dosyaadi }}</th>
                      <th scope="row">{{ Data.birimadi }}</th>

                      <td>
                        <div v-for="turler in Ihaleturu" :key="turler.Id" :value="turler.Id">
                          <div v-if="turler.Id == Data.ihaleturu">{{ turler.Value }}</div>
                        </div>
                      </td>

                      <td>
                        <div v-for="turler in Alimturu" :key="turler.Id" :value="turler.Id">
                          <div v-if="turler.Id == Data.alimturu">{{ turler.Value }}</div>
                        </div>
                      </td>

                      <td>{{ Data.dosyaacilistarih | formatDateTable }}</td>

                      <td style="width: 100px; text-align: center;">
                        <b-button-group>
                          <b-button variant="primary" :to="'/dosyaislemleri/' + Data.Id"><i
                              class="fas fa-folder-open"></i></b-button>
                          <b-button variant="success" v-b-modal.satdosya
                            @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                          <b-button variant="danger" @click="DeleteandDeleteStrHarcama(Data.Id)"><i
                              class="far fa-trash-alt"></i></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002" >
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("satdosya.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("satdosya.Filtreleme.Content") }}
            <hr />
            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("satdosya.Filtreleme.dosyaadi") }}</label>
              <b-form-input for="text" v-model="Filter.dosyaadi" value=""></b-form-input>
            </div>
            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("satdosya.Filtreleme.Dosyaacilistarih_ilk") }}</label>
              <b-form-input id="datebs" v-model="Filter.Dosyaacilistarih_ilk" value="" type="date"></b-form-input>
            </div>

            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("satdosya.Filtreleme.Dosyaacilistarih_son") }}</label>
              <b-form-input id="datebs" v-model="Filter.Dosyaacilistarih_son" value="" type="date"></b-form-input>
            </div>
            <div class="mb-3" style="width: 350px;">
            
  
            <BirimSecimi
              :title="$t('StrBirimButceHarcamalari.Filtreleme.BirimId')"
              :sutun="'0'" 
              :title_position="'mb-3'"
              :selected="Filter.ihaleyiyapanmakam"
              :labels_lg="'3'"  
              :YetkiKontrol="1"
              :multiple="false"
              :BirimTipId="null"
              @Secilmis_Idler="Filter.ihaleyiyapanmakam=$event"
              :v="null"
            />
   


      </div>

            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("satdosya.Filtreleme.ihaleturu") }}</label>
              <select v-model="Filter.ihaleturu" class="form-select" type="text">
                <option value="">Seçiniz</option>
                <option v-for="turler in Ihaleturu" :key="turler.Id" :value="turler.Id">
                  {{ turler.Value }}
                </option>
              </select>
            </div>

            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("satdosya.Filtreleme.alimturu") }}</label>
              <select v-model="Filter.alimturu" class="form-select" type="text">
                <option value="">Seçiniz</option>
                <option v-for="alim in Alimturu" :key="alim.Id" :value="alim.Id">
                  {{ alim.Value }}
                </option>
              </select>
            </div>
            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("satdosya.Filtreleme.tamamlandi") }}</label>
              <select v-model="Filter.tamamlandi" class="form-select" type="text">
                <option value="">Seçiniz</option>
                <option value=true>Evet</option>
                <option value=false>Hayır</option>
              </select>
            </div>

          <b-button @click="Get" class="btn btn-primary" variant="primary">{{ $t("satdosya.Filtreleme.Button")
            }}</b-button>
        </div>
      </div>
    </Drawer>
  </Layout>
</Loader></template>
